import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define a service using a base URL and expected endpoints
export const emeattendanceApi = createApi({
  reducerPath: 'emeattendance',
  baseQuery: btBaseQuery,
  tagTypes: ['Attendance'],

  endpoints: (builder) => ({
    getAttendances: builder.query<em_eattendance[], string>({
      query: (cid) => `emattendance/${cid}`,
      providesTags: ['Attendance']
    }),
    getAttendance: builder.query<em_eattendance, string>({
      query: (id) => `emattendance/byid/${id}`
    }),
    getAttendancesByDate: builder.query<em_eattendance[], any>({
      query: ({ cid, fdt, tdt }) => `emattendance/bydate/${cid}/${fdt}/${tdt}`
    }),
    insertAttendance: builder.mutation({
      query: (emattendance) => ({
        url: `emattendance/`,
        method: 'POST',
        body: emattendance
      }),
      invalidatesTags: ['Attendance']
    }),
    updateAttendance: builder.mutation({
      query: (emattendance) => ({
        url: `emattendance/`,
        method: 'PUT',
        body: emattendance
      }),
      invalidatesTags: ['Attendance']
    }),
    deleteAttendance: builder.mutation({
      query: (emattendance) => ({
        url: `emattendance/${emattendance.at_id}`,
        method: 'DELETE',
        body: emattendance
      }),
      invalidatesTags: ['Attendance']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAttendancesQuery,
  useGetAttendanceQuery,
  useGetAttendancesByDateQuery,
  useLazyGetAttendancesByDateQuery,
  useInsertAttendanceMutation,
  useUpdateAttendanceMutation,
  useDeleteAttendanceMutation
} = emeattendanceApi;
